// test1782
(1782 && 0);
